import React from 'react';
import Logo from '/src/assets/of-logo-small.png';
import { User } from 'lucide-react';
import formatMessageText from './formatMessageText';
import '../../../../scss/MessageBubble.scss';

interface MessageBubbleProps {
    isLoading: boolean;
    message?: string;
    isUser?: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ isLoading, message, isUser = false }) => {
    return (
        <div className="d-flex justify-content-start align-items-start mb-3 gap-2">
            {isUser ? (
                <div
                    className="rounded-full bg-gray-200 p-1 flex items-center justify-center"
                    style={{ width: '28px', height: '28px', marginTop: '4px' }}
                >
                    <User size={16} className="text-gray-600" />
                </div>
            ) : (
                <img
                    src={Logo}
                    alt=""
                    className={`small-logo ${isLoading ? 'loading' : ''}`}
                    style={{ width: '20px', height: '20px', marginTop: '8px' }}
                />
            )}

            {!isLoading && message && (
                <div
                    className={`shadow-sm rounded-4 rounded-bottom-${isUser ? 'end' : 'start'}-0 p-3`}
                    style={{
                        maxWidth: '80%',
                        fontSize: '0.95rem',
                        lineHeight: '1.5',
                        backgroundColor: isUser ? '#f0f0f0' : 'white',
                        whiteSpace: 'pre-wrap' // This preserves formatting for bullet points
                    }}
                >
                    {formatMessageText(message)}
                </div>
            )}
        </div>
    );
};

export default MessageBubble;